(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-thumb-hover"] && !Shopify.designMode) return;
  try {
    (function () {
    var MEDIA_QUERY = '(min-width: 1150px) and (hover: hover) and (pointer: fine)';
    var lastSlide = null;

    function canHover() {
      return window.matchMedia && window.matchMedia(MEDIA_QUERY).matches;
    }

    document.addEventListener(
      'mouseover',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var slide = target.closest('.hdt-product-media__thumb .hdt-slider__slide');
        if (!slide || slide === lastSlide) return;

        var gallery = slide.closest('[data-thumb-hover="true"]');
        if (!gallery) return;
        if (!canHover()) return;

        lastSlide = slide;

        // Already showing: nothing to do.
        if (slide.classList.contains('is-thumb-selected')) return;

        // Gallery media on this theme can be tied to a variant. Moving to one
        // of those also switches the selected variant and the price, so a hover
        // would silently re-price the product. Preview only the media that are
        // not variant-linked; those still need a deliberate click.
        var thumbs = gallery.querySelectorAll('.hdt-product-media__thumb .hdt-slider__slide');
        var mains = gallery.querySelectorAll('.hdt-product-media__main .hdt-product__media-item');
        var index = Array.prototype.indexOf.call(thumbs, slide);
        var main = mains[index];
        if (!main || main.hasAttribute('data-variants-id')) return;

        // The thumb slider listens for clicks on the slide, so reuse its own
        // path rather than reaching into its internals.
        slide.click();
      },
      { passive: true }
    );

    document.addEventListener(
      'mouseout',
      function (event) {
        if (!event.relatedTarget || !event.relatedTarget.closest) {
          lastSlide = null;
          return;
        }
        if (!event.relatedTarget.closest('.hdt-product-media__thumb')) lastSlide = null;
      },
      { passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
